export const getHrefElm = (editor, selectedElm) => {
  // tinyMCE v5.1.5のリンクDOM構造でも動作するように、クリックした要素だけでなく、再帰的にその親を検索して、href要素を取得
  if (!selectedElm && !editor.selection) return null
  selectedElm = selectedElm || editor.selection.getNode()
  return editor.dom.getParent(selectedElm, '[href]')
}

// 以下、https://github.com/tinymce/tinymce/blob/5.5.0/modules/tinymce/src/plugins/link/main/ts/core/Utils.ts
// から必要なものをそのまま持ってきた
export const unlinkDomMutation = (editor) => {
  editor.undoManager.transact(() => {
    const node = editor.selection.getNode()
    if (isImageFigure(node)) {
      unlinkImageFigure(editor, node)
    } else {
      unlinkSelection(editor)
    }
    editor.focus()
  })
}

const isImageFigure = (elm) => elm && elm.nodeName === 'FIGURE' && /\bimage\b/i.test(elm.className)

export const unlinkImageFigure = (editor, fig) => {
  const img = editor.dom.select('img', fig)[0]
  if (img) {
    const a = editor.dom.getParents(img, 'a[href]', fig)[0]
    if (a) {
      a.parentNode.insertBefore(img, a)
      editor.dom.remove(a)
    }
  }
}

const unlinkSelection = (editor) => {
  const dom = editor.dom
  const selection = editor.selection
  const bookmark = selection.getBookmark()
  const rng = selection.getRng().cloneRange()

  // Extend the selection out to the entire anchor element
  const startAnchorElm = dom.getParent(rng.startContainer, 'a[href]', editor.getBody())
  const endAnchorElm = dom.getParent(rng.endContainer, 'a[href]', editor.getBody())
  if (startAnchorElm) {
    rng.setStartBefore(startAnchorElm)
  }
  if (endAnchorElm) {
    rng.setEndAfter(endAnchorElm)
  }
  selection.setRng(rng)

  // Remove the link
  editor.execCommand('unlink')
  selection.moveToBookmark(bookmark)
}
